import MaximetersWidget from './MaximetersWidget';

export default MaximetersWidget;
